/** @format */

import { createPinia, Pinia } from 'pinia';
import type { App } from 'vue';

const store: Pinia = createPinia();

export function setupStore(app: App<Element>) {
	app.use(store);
}

export { store };

export * from './modules';
